<template>
  <section class="request-card-duplicate-page mt-4">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header title="2ª via de cartão"></app-page-header>

    <div class="container">
      <p class="info-text">
        O envio da primeira via do cartão é realizado automaticamente mediante
        inscrição no Clube Venda & Ganhe. Ela é enviada para o endereço
        cadastrado no seu perfil. Caso você NÃO TENHA RECEBIDO A 1ª VIA, entre
        em contato pelo e-mail:
        <a href="mailto:atendimento@clubevendaeganhe.com.br"
          >atendimento@clubevendaeganhe.com.br</a
        >
        ou pelo telefone: (41) 3114-7282. Se você JÁ RECEBEU sua primeira via do
        cartão, mas extraviou ou perdeu a mesma, PROSSIGA COM A SOLICITAÇÃO DA
        2ª VIA. A segunda via do cartão tem custo de R$15 reais descontado,
        diretamente do saldo do seu cartão.
      </p>

      <div class="card-box">
        <div class="card-box__address">
          <p class="header">Endereço</p>
          <div class="address">
            <p>{{ client.address.street }}, {{ client.address.number }}</p>
            <p>{{ client.address.neighborhood }}</p>
            <p>
              {{ client.address.city.name }} -
              {{ client.address.city.state.code }}
            </p>

            <router-link :to="{ name: 'site.my-info' }">Editar</router-link>
          </div>
        </div>
        <div class="card-box__image">
          <img src="@/assets/img/cards.png" alt="Cartões" />
        </div>
        <div class="card-box__info">
          <div class="info-item">
            <div class="header">
              <p>Total de Pontos</p>
            </div>
            <div class="content">
              <div class="value">{{ points }}</div>
              <div class="text">Conversão: {{ conversion | currency }}</div>
            </div>
          </div>
          <div class="info-item">
            <div class="header">
              <p>Disponíveis para Resgate</p>
            </div>
            <div class="content">
              <div class="value">{{ points }}</div>
              <div class="text">Conversão: {{ conversion | currency }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="message-container">
        <b-field label="Motivo da solicitação">
          <b-input
            v-model="reason"
            placeholder="Escreva aqui o motivo da sua solicitação..."
            maxlength="256"
            type="textarea"
          ></b-input>
        </b-field>
      </div>

      <div class="button-container">
        <button @click="onRequest()" :disabled="!reason" type="button">
          Solicitar 2ª Via
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import ExchangeService from '@/services/exchange.service';
import ClientService from '@/services/client.service';
import { UPDATE_USER } from '@/store/actions/auth';

export default {
  name: 'request-card-duplicate-page',
  data: () => {
    return {
      isLoading: true,
      exchange: null,
      reason: null,
      client: {
        address: {
          city: {
            state: {},
          },
        },
      },
    };
  },
  computed: {
    points() {
      return this.$store.getters.userPoints;
    },
    conversion() {
      return this.exchange ? this.exchange.value * this.points : 0;
    },
  },
  methods: {
    load() {
      this.isLoading = true;

      Promise.all([ClientService.getSelf(), ExchangeService.get()])
        .then(([{ data: client }, { data: exchange }]) => {
          this.exchange = exchange;
          this.client = client;
          this.redeemPoints = client.points;
          this.$store.dispatch(UPDATE_USER, { points: client.points });
        })
        .finally(() => setTimeout(() => (this.isLoading = false), 200));
    },
    onRequest() {
      this.$buefy.dialog.confirm({
        message:
          'Tem certeza que deseja realizar a solicitação de segunda via do cartão?',
        cancelText: 'Cancelar',
        confirmText: 'Sim',
        type: 'is-primary',
        onConfirm: () => this.request(),
      });
    },
    request() {
      this.isLoading = true;

      ClientService.requestCardDuplicate(this.reason)
        .then(() => { 
          this.toastify('Solicitação feita com sucesso.');
          this.$router.push('/');
        })
        .catch(({ response }) => {
          this.isLoading = false;
          this.toastify(response.data.message, 'error');
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
section.request-card-duplicate-page {
  p.info-text {
    margin: auto;
    color: var(--text-color-light);
    font-size: 1.1em;
    max-width: 80%;
  }

  .card-box {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    background: #e5e5e5;
    padding: 16px;
    margin: 32px 0;
    border-radius: 8px;

    &__address {
      flex: 0 25%;

      .header {
        font-size: 1.2em;
        color: var(--text-color);
        font-weight: bold;
        text-transform: uppercase;
      }

      .address {
        margin-top: 16px;
        color: var(--text-color-medium);
      }
    }

    &__info {
      padding: 32px 0;

      .info-item {
        margin-bottom: 32px;

        &:nth-child(2) {
          div.value {
            color: var(--color-secondary);
          }
        }

        .header {
          font-size: 1.2em;
          color: var(--text-color);
          font-weight: bold;
          text-transform: uppercase;
        }

        .content {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .value {
            font-weight: bold;
            color: var(--color-primary);
            font-size: 1.2em;
          }

          .text {
            color: var(--text-color-light);
          }
        }
      }
    }
  }

  .button-container {
    text-align: right;

    button {
      border: none;
      background: #e5e5e5;
      color: var(--text-color);
      padding: 16px 32px;
      border-radius: 6px;
      font-size: 1.2em;
      transition: 0.2s ease-in-out;
      cursor: pointer;

      &:disabled {
        color: #ccc;

        &:hover {
          cursor: not-allowed;
        }
      }

      &:hover:not(:disabled) {
        background: #d5d5d5;
      }
    }
  }
}

@media(max-width: 992px) {
  section.request-card-duplicate-page {
    padding: 0 1em;

    p.info-text {
      padding: 0;
      margin: 0;
      width: 100%;
      max-width: 100%;
    }
    .card-box {
      flex-direction: column;
    }
  }
}
</style>
